import api from '@services/axios';

export const updateWorkItemAction = async (id, actionKey) => {
  const response = await api.jsonAPI().patch(`/work_items/${id}/${actionKey}`);
  return response.data;
};
